// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"d4","label":"d5","downloadSize":"d6","selectorWrapper":"d7","selected":"d8"};